import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { RaisedButton, Dialog } from 'material-ui';

import { changePort } from 'actions/regions/ports';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { TextField } from 'redux-form-material-ui';

import { length, required, numericality } from 'redux-form-validators';
import { formName } from 'data/formNames';

const styles = {
    dialog: {
        contentStyle: { width: '500px', padding: '18px' },
    },
    textField: {
        floatingLabelStyle: {
            fontSize: '12px',
        },
    },
};

class AddDetail extends React.Component {
    constructor(props) {
        super(props);

        this.onRequestClose = this.onRequestClose.bind(this);
    }

    onRequestClose() {
        this.props.toggle();
        this.props.fields.pop();
    }

    render() {
        const {
            open, toggle, field, name, min, max, 
        } = this.props;

        return (
            <Dialog
                open={open}
                contentStyle={styles.dialog.contentStyle}
                onRequestClose={this.onRequestClose}
            >
                <Fragment>
                    <form>
                        <div className='dialog-header'>
                            add capacity between {name} mt
                        </div>

                        <Field
                            component={TextField}
                            name={`${field}.name`}
                            floatingLabelText='Name'
                            fullWidth
                            floatingLabelStyle={styles.textField.floatingLabelStyle}
                            validate={[length({ max: 266 })]}
                        />

                        <Field
                            component={TextField}
                            name={`${field}.value`}
                            floatingLabelText='Value'
                            fullWidth
                            floatingLabelStyle={styles.textField.floatingLabelStyle}
                            validate={[required(), numericality({ '<=': max, '>=': min, int: true })]}
                        />

                        <RaisedButton
                            label='Cancel'
                            primary
                            onClick={this.onRequestClose}
                        />

                        <RaisedButton
                            label='Add'
                            onClick={this.props.handleSubmit((submit) => {
                                toggle();
                                this.props.changePort(submit);
                            })}
                        />
                    </form>
                </Fragment>
            </Dialog>
        );
    }
}


AddDetail.propTypes = {};

AddDetail.defaultProps = {};

const FormAddDetail = reduxForm({
    form: formName.portUpdateAddDetail,
    enableReinitialize: true,
})(AddDetail);

const selector = formValueSelector(formName.portUpdate);
export default connect(
    (state, ownProps) => ({
        initialValues: { liftsCranes: selector(state, 'liftsCranes') },
        name: ownProps.name,
        min: ownProps.min,
        max: ownProps.max,
    }),
    dispatch => bindActionCreators({
        changePort,
    }, dispatch),
)(FormAddDetail);



// WEBPACK FOOTER //
// ./app/components/Regions/Port/LiftAndCranes/AddDetail.jsx